import React from 'react';
import { FOOTER_LINKS_LIST } from 'Utils/Constants';

import './LightFooter.css';

export const LightFooter = () => (
  <div className="accountFooter">
    <ul className="accountFooterList">
      {FOOTER_LINKS_LIST.map(({ name, href }, i) => (
        <li key={`accountFooter-link-${i}`} className="accountFooterListItem">
          <a href={href} className="accountFooterListLink">
            {name}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
